// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"132":"f87145fb","453":"a492ffeb","809":"e948fa28"}[chunkId] + ".chunk.js";
};